<script lang="ts">
  import TextField from "./TextField.svelte";

  export let name: string;
  export let key: string;

  export let limit = 0;
  export let required = false;
  export let placeholder = "";
  export let autofocus = false;
  export let disabled = false;
  export let hideBorder = false;

  // https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
  const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
</script>

<TextField {key} {name} {limit} {required} {placeholder} {autofocus} {disabled} {hideBorder} pattern={EMAIL_REGEX} />
